import { colors } from "@clockwise/web-commons/src/styles/color.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";
import { size, weight } from "@clockwise/web-commons/src/styles/type.styles";

export const divider = {
  marginBottom: spacing.std,
  marginTop: spacing.std,
} as const;

export const title = {
  marginBottom: spacing.std,
  color: colors.blueDusk.standard,
} as const;

export const collaborator = {
  container: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: spacing.sm,
    fontSize: size.md,
  },
  number: {
    marginRight: spacing.sm,
  },
  name: {
    fontWeight: weight.std,
    borderBottomWidth: 0,
  },
} as const;
